<section class="content">
  <app-breadcrumbs type="newProfileReport"></app-breadcrumbs>
  <div class="card" [ngClass]="!(profileState | async).loader['auditAdd']['add'] ? 'background-loader' : ''">
    <div class="card-body-generate text-center">
      <div class="spinner" *ngIf="!(profileState | async).loader['auditAdd']['add']"></div>
      <app-profile-form size="large" [redirect]="true"></app-profile-form>
    </div>
  </div>
</section>
